import React, { useEffect, useState } from "react";
import { Page, Grid } from "tabler-react";
import { withRouter, NavLink } from "react-router-dom";
import * as authService from "../store/services/authServices";
import PageFooter from "./PageFooter";

const SuccessPage = () => {
  return (
    <Page>
      <div className="login-page">
        <Grid.Row>
          <div className="col-lg-6">
            <Grid.Row>
              <div
                className="col-md-6 col-lg-8 form-body"
                style={{ marginTop: "auto" }}
              >
                <label className="welcome-title">Email Verified!</label>
                <label className="label-title">
                  If you came from the Mobility Measure app, please go back to the app to log in.
                </label>
                <label className="label-title" style={{ marginTop: "12px" }}>
                  Or if you'd like to use the web app, <NavLink to="/login">log in here</NavLink>.
                </label>
              </div>
            </Grid.Row>
          </div>
          <div className="col-lg-6 ">
            <div className="ev-logo verified-logo"></div>
          </div>
        </Grid.Row>
        <PageFooter />
      </div>
    </Page>
  );
};

const ErrorPage = ({ message }) => (
  <Page>
    <div className="login-page">
      <Grid.Row>
        <div className="col-lg-6">
          <Grid.Row>
            <div
              className="col-md-6 col-lg-8 form-body"
              style={{ marginTop: "auto" }}
            >
              <label className="welcome-title">Verification Failed</label>
              <label className="label-title">{message}</label>
              <label className="label-title" style={{ marginTop: "12px" }}>
                <NavLink to="/login">Go to login</NavLink> to request a new verification email.
              </label>
            </div>
          </Grid.Row>
        </div>
        <div className="col-lg-6">
          <div className="ev-logo verified-logo"></div>
        </div>
      </Grid.Row>
      <PageFooter />
    </div>
  </Page>
);

function VerifyEmailPage(props) {
  const params = new URLSearchParams(props.location.search);
  const path = params.get("queryURL");
  const [isLoading, setSubmit] = useState(!!path);
  const [isVerified, setRequested] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (!path) {
      setErrorMessage("No verification link found. Please check your email and try again.");
      setSubmit(false);
      return;
    }
    setSubmit(true);
    authService
      .verifyEmail(path)
      .then(() => {
        setRequested(true);
        setSubmit(false);
      })
      .catch((error) => {
        const status = error.response?.status;
        if (status === 403) {
          setErrorMessage("This verification link has expired. Please log in to request a new one.");
        } else if (status === 422) {
          setErrorMessage("This verification link is invalid. Please log in to request a new one.");
        } else {
          setErrorMessage("Something went wrong. Please try again or contact support.");
        }
        setSubmit(false);
      });
  }, [path]);

  if (isLoading) return null;
  if (isVerified) return <SuccessPage />;
  return <ErrorPage message={errorMessage} />;
}

export default withRouter(VerifyEmailPage);
